import React from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';

const PageHeader = ({ title, icon, description, category, noSidePadding = false }) => {
  const theme = useTheme();
  
  return (
    <Box sx={{ 
      mb: 4,
      pb: 2,
      position: 'relative',
      borderRadius: '12px',
      overflow: 'hidden',
      width: '100%',
      px: noSidePadding ? 0 : { xs: 2, md: 4 },
    }}>
      <Box 
        sx={{ 
          width: '100%',
          py: 2
        }}
      >
        {/* Category Tag */}
        {category && (
          <Box sx={{ 
            display: 'inline-flex',
            alignItems: 'center',
            background: alpha('#4158D0', 0.08),
            color: '#4158D0',
            px: 1.5,
            py: 0.4,
            borderRadius: '6px',
            mb: 1.5,
          }}>
            <Typography 
              variant="caption" 
              sx={{ 
                fontWeight: 600,
                letterSpacing: '0.03em',
                fontSize: '0.7rem',
                textTransform: 'uppercase',
              }}
            >
              {category}
            </Typography>
          </Box>
        )}

        {/* Title with Icon */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 2,
          mb: 0.5
        }}>
          {icon && icon}
          <Typography 
            variant="h1" 
            sx={{ 
              fontWeight: 700,
              color: '#1A2034',
              fontSize: { xs: '1.5rem', sm: '1.75rem' },
              lineHeight: 1.3,
              letterSpacing: '-0.01em',
            }}
          >
            {title}
          </Typography>
        </Box>

        {/* Description */}
        {description && (
          <Typography 
            variant="body1" 
            sx={{ 
              color: alpha('#1A2034', 0.65),
              maxWidth: '800px',
              lineHeight: 1.5,
              mt: 0.5,
              fontSize: '0.95rem',
            }}
          >
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default PageHeader;